import * as React from "react";

import { RobotoTypography } from "@/shared/components";

export const ActionConfigurationGuidance: React.FC = () => {
  return (
    <RobotoTypography variant="body2" component={"span"}>
      This setting controls whether action inputs will be downloaded to{" "}
      <strong>$ROBOTO_INPUT_DIR</strong> at the start of an invocation. Set to{" "}
      <pre style={{ display: "inline" }}>true</pre> by default, it ensures the
      inputs are downloaded and mounted to the action&apos;s filesystem. Roboto
      ingestion actions, for instance, make use of this to extract topics,
      message paths, events and more from dataset files.
      <br /> <br />
      If your action works with processed topic data instead of raw input files,
      you can set this to <pre style={{ display: "inline" }}>false</pre>. Doing
      so will speed up your action invocations as the downloading step is
      skipped.
    </RobotoTypography>
  );
};
